// NPM Imports
import React, { useState } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

// Component Imports
import FeatureGating from "../FeatureGating";
import UpgradePopUp from "../UpgradePopUp";

// Internal Imports
import { FEATURES } from "../../constants";

// Destructuring
const { UPGRADE_TEXT } = FEATURES;

export function MeteredCounterDefault(props) {
  const { count: { limit = 0, usage = 0 } = {} } = props;
  const title = UPGRADE_TEXT[props.name].counterData.title || "Available";

  return (
    <div className="metered-counter-wrapper">
      {usage}/{limit} {title}{" "}
      {/* <FontAwesomeIcon
        icon={["far", "info-circle"]}
        className="metered-counter-info"
      /> */}
    </div>
  );
}

export function MeteredCounterUpgrade(props) {
  const [showPopUp, togglePopUp] = useState(false);
  const { count: { limit = 0, usage = 0 } = {} } = props;
  const title = UPGRADE_TEXT[props.name].counterData.title || "Available";
  return (
    <div className="metered-counter-wrapper">
      {usage}/{limit} {title} Want more?
      <span
        className="metered-counter-upgrade-btn"
        role="button"
        tabIndex={0}
        onClick={() => togglePopUp(true)}
        onKeyDown={() => togglePopUp(true)}>
        Upgrade Now
      </span>
      {showPopUp && (
        <UpgradePopUp
          featureName={props.name}
          onClose={() => togglePopUp(false)}
        />
      )}
    </div>
  );
}

export default function(props) {
  return (
    <FeatureGating
      isMeteredCounterComponent
      altComponent={<MeteredCounterUpgrade {...props} />}
      {...props}>
      <MeteredCounterDefault {...props} />
    </FeatureGating>
  );
}



// WEBPACK FOOTER //
// ./src/commonComponents/MeteredCounter/index.js